/*
* Palo Alto Theme - Custom JS
*/

(function() {

  var BASE_PRICE = null;
  var COMPARE_PRICE = null;
  var CURRENCY_SYMBOL = null;
  var SUBSCRIBE_DISCOUNT = 0.9; // 10% off, keep in sync with badge text

  var planQuantities = {
    '691952714054': 1,
    '693787164998': 2,
    '691952746822': 3
  };

  var planLabels = {
    '691952714054': { main: '1 tub', sub: 'every month' },
    '693787164998': { main: '2 tubs', sub: 'every 2 months' },
    '691952746822': { main: '3 tubs', sub: 'every 3 months' }
  };

  var planBadgeIds = {
    '691952714054': 'gigi-subscription-badge-text',
    '693787164998': 'gigi-subscription-badge-text-2',
    '691952746822': 'gigi-subscription-badge-text-3'
  };

  var badgeStyle = 'position:absolute;top:-12px;left:50%;transform:translateX(-50%);white-space:nowrap;display:inline-flex;align-items:center;gap:4px;background:#FAFAF7;color:#223B51;border:1.5px solid #223B51;font-size:9.2px;font-weight:600;letter-spacing:0.07em;text-transform:uppercase;padding:3px 8px 2px;border-radius:20px;z-index:10;line-height:1.6;';

  var giftIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#223B51" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';

  function getSubscriptionBadgeText(planId) {
    var divId = planId ? planBadgeIds[planId] : 'gigi-subscription-badge-text';
    var el = document.getElementById(divId || 'gigi-subscription-badge-text');
    if (el) return el.getAttribute('data-badge-text') || '';
    return '';
  }

  function inject() {
    // Derive prices + currency from the one-time price element (most reliable across markets)
    if (BASE_PRICE === null || COMPARE_PRICE === null || CURRENCY_SYMBOL === null) {
      var oneTimePriceEl = document.querySelector('[data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price');
      if (oneTimePriceEl && oneTimePriceEl.textContent.trim()) {
        var raw = oneTimePriceEl.textContent.trim();
        var symbol = raw.replace(/[\d.,\s]/g, '');
        var oneTimePrice = parseFloat(raw.replace(/[^0-9.]/g, ''));
        if (oneTimePrice > 0) {
          CURRENCY_SYMBOL = symbol || '\u20ac';
          COMPARE_PRICE = oneTimePrice;
          BASE_PRICE = +(oneTimePrice * SUBSCRIBE_DISCOUNT).toFixed(2);
        }
      }
    }

    // Labels
    Object.keys(planLabels).forEach(function(id) {
      var btn = document.getElementById('loop-widget-sp-button-id-' + id);
      if (!btn) return;
      if (!btn.querySelector('.gigi-card-label')) {
        btn.childNodes.forEach(function(node) {
          if (node.nodeType === 3) node.textContent = '';
        });
        var wrapper = document.createElement('span');
        wrapper.className = 'gigi-card-label';
        wrapper.style.cssText = 'display:block;text-align:center;';
        var main = document.createElement('span');
        main.style.cssText = 'display:block;font-size:13px;font-weight:700;color:#223B51;line-height:1.3;';
        main.textContent = planLabels[id].main;
        var sub = document.createElement('span');
        sub.style.cssText = 'display:block;font-size:11px;font-weight:400;color:rgba(34,59,81,0.6);line-height:1.4;margin-top:2px;';
        sub.textContent = planLabels[id].sub;
        wrapper.appendChild(main);
        wrapper.appendChild(sub);
        btn.appendChild(wrapper);
      }
    });

    // Most Popular badge
    var btn2 = document.getElementById('loop-widget-sp-button-id-693787164998');
    if (btn2 && !btn2.querySelector('.gigi-badge-popular')) {
      var badge = document.createElement('span');
      badge.className = 'gigi-badge-popular';
      badge.style.cssText = badgeStyle;
      badge.textContent = 'Most popular';
      btn2.appendChild(badge);
    }

    // Free Gift badge, driven by metafield
    var btn3 = document.getElementById('loop-widget-sp-button-id-691952746822');
    var giftEl = document.getElementById('gigi-free-gift-text');
    var giftText = giftEl ? (giftEl.getAttribute('data-badge-text') || '').trim() : '';
    if (btn3 && giftText && !btn3.querySelector('.gigi-badge-gift')) {
      var giftBadge = document.createElement('span');
      giftBadge.className = 'gigi-badge-gift';
      giftBadge.style.cssText = badgeStyle;
      giftBadge.innerHTML = giftIcon + ' ' + giftText;
      btn3.appendChild(giftBadge);
    }

    // Subscription badge, per selected plan
    var selected = document.querySelector('.loop-widget-sp-button.loop-widget-sp-button-selected');
    var activePlanId = selected ? selected.dataset.sellingPlanId : '691952714054';
    var badgeText = getSubscriptionBadgeText(activePlanId);
    var subHeader = document.querySelector('[data-loop-widget-selling-plan-group] .loop-widget-spg-label-discount-wrapper');
    if (subHeader) {
      var existing = document.querySelector('.gigi-sub-badge');
      if (!existing) {
        if (badgeText) {
          var subBadge = document.createElement('div');
          subBadge.className = 'gigi-sub-badge loop-widget-purchase-option-discount-badge';
          subBadge.textContent = badgeText;
          subHeader.appendChild(subBadge);
        }
      } else {
        existing.textContent = badgeText;
      }
    }

    // Price
    if (selected) {
      var planId = selected.dataset.sellingPlanId;
      var qty = planQuantities[planId] || 1;
      var symbol = CURRENCY_SYMBOL || '\u20ac';
      var priceEl = document.querySelector('.loop-widget-purchase-option-price:not([id*="onetime"])');
      if (priceEl && BASE_PRICE) priceEl.textContent = symbol + (BASE_PRICE * qty).toFixed(2);
      var compareEl = document.querySelector('.loop-widget-purchase-option-compare-at-price');
      if (compareEl) {
        if (COMPARE_PRICE > 0) {
          compareEl.textContent = symbol + (COMPARE_PRICE * qty).toFixed(2);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    }

    // Quantity
    var quantityInput = document.querySelector('.product__form input[name="quantity"]');
    if (quantityInput) {
      var oneTime = document.querySelector('[data-loop-widget-onetime-purchase-option][aria-checked="true"]');
      if (oneTime) {
        if (quantityInput.value != 1) { quantityInput.value = 1; quantityInput.dispatchEvent(new Event('change', {bubbles:true})); }
      } else if (selected) {
        var newQty = planQuantities[selected.dataset.sellingPlanId] || 1;
        if (quantityInput.value != newQty) { quantityInput.value = newQty; quantityInput.dispatchEvent(new Event('change', {bubbles:true})); }
      }
    }

    // Expanded
    var subscribeSelected = document.querySelector('[data-loop-widget-selling-plan-group][aria-checked="true"]');
    if (subscribeSelected) {
      var spg = subscribeSelected.querySelector('.loop-widget-spg-container');
      if (spg && !spg.classList.contains('expanded')) spg.classList.add('expanded');
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    var loopContainer = document.getElementById('loop-widget-container-id-8424653652294');
    var watchTarget = loopContainer || document.querySelector('.loop-widget-container') || document.body;
    var debounceTimer = null;

    new MutationObserver(function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(inject, 0);
    }).observe(watchTarget, { childList: true, subtree: true });

    document.querySelectorAll('.radio__label').forEach(function(label) {
      label.addEventListener('click', function() {
        setTimeout(inject, 200);
        setTimeout(inject, 500);
        setTimeout(inject, 900);
      });
    });

    setTimeout(inject, 500);
    setTimeout(inject, 1000);
  });

})();

/* ============================================================
   Cart upsell layout enforcement.
   theme.js auto-initialises Flickity on [data-pair-products]
   whenever there is more than one upsell card. The theme-editor
   layout settings (Theme settings -> Upsells) offer list/grid
   alternatives; for those we destroy the Flickity instance so the
   CSS layout in gigi-upsells.css takes over. Carousel = native
   behaviour, untouched.
   ============================================================ */
(function () {
  function enforceUpsellLayouts() {
    var wraps = document.querySelectorAll('[data-pair-products]');
    if (!wraps.length) return;
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    wraps.forEach(function (wrap) {
      var layout = isMobile
        ? wrap.getAttribute('data-layout-mobile')
        : wrap.getAttribute('data-layout-desktop');
      if (layout === 'carousel' || !layout) return;
      var Flkty = window.theme && window.theme.Flickity;
      var instance = Flkty && Flkty.data ? Flkty.data(wrap) : null;
      if (instance) instance.destroy();
    });
  }

  /* Selection persistence.
     The upsell holder's HTML is REPLACED on every cart update (AJAX section
     re-render), which silently reset the flavour pills and purchase-option
     select to their defaults: pick Blood Orange, change any quantity, tap
     Quick Buy - and Lemon was added. Selections are stored per product
     handle for the session and re-applied after each re-render. */
  function upsellHandleFor(el) {
    var holder = el.closest('[data-upsell-holder]');
    var btn = holder && holder.querySelector('[data-upsell-btn]');
    return btn ? btn.getAttribute('data-handle') : null;
  }

  /* Compact card: the square photo follows the chosen pill (each pill
     carries its variant's photo in data-thumb, see upsell-products.liquid). */
  function syncUpsellThumb(holder) {
    var img = holder && holder.querySelector('[data-upsell-thumb]');
    var input = holder && holder.querySelector('[data-upsell-variant-pill] input[name="id"]:checked');
    var pill = input && input.closest('[data-upsell-variant-pill]');
    if (!img || !pill || !pill.getAttribute('data-thumb')) return;
    var src = pill.getAttribute('data-thumb');
    if (img.getAttribute('src') === src) return;
    img.setAttribute('srcset', src + ' 200w, ' + (pill.getAttribute('data-thumb-2x') || src) + ' 400w');
    img.setAttribute('src', src);
    img.setAttribute('alt', pill.getAttribute('data-thumb-alt') || img.getAttribute('alt') || '');
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input.matches && input.matches('[data-upsell-variant-pill] input[name="id"]')) {
      var handle = upsellHandleFor(input);
      if (handle) sessionStorage.setItem('gigi:upsell:variant:' + handle, input.value);
      syncUpsellThumb(input.closest('[data-upsell-holder]'));
    }
    if (input.matches && input.matches('select[name="selling_plan"].product-upsell__plan')) {
      var planHandle = upsellHandleFor(input);
      if (planHandle) sessionStorage.setItem('gigi:upsell:plan:' + planHandle, input.value);
    }
  });

  function restoreUpsellSelections() {
    document.querySelectorAll('[data-upsell-holder]').forEach(function (holder) {
      var btn = holder.querySelector('[data-upsell-btn]');
      var handle = btn && btn.getAttribute('data-handle');
      if (!handle) return;
      var savedVariant = sessionStorage.getItem('gigi:upsell:variant:' + handle);
      if (savedVariant) {
        var radio = holder.querySelector('[data-upsell-variant-pill] input[value="' + savedVariant + '"]');
        if (radio && !radio.checked) radio.checked = true;
      }
      syncUpsellThumb(holder);
      var savedPlan = sessionStorage.getItem('gigi:upsell:plan:' + handle);
      if (savedPlan !== null) {
        var select = holder.querySelector('select[name="selling_plan"].product-upsell__plan');
        if (select && select.value !== savedPlan) {
          var hasOption = [].some.call(select.options, function (o) { return o.value === savedPlan; });
          if (hasOption) select.value = savedPlan;
        }
      }
    });
  }

  var upsellLayoutTimer = null;
  function scheduleUpsellLayouts() {
    clearTimeout(upsellLayoutTimer);
    upsellLayoutTimer = setTimeout(function () {
      enforceUpsellLayouts();
      restoreUpsellSelections();
    }, 50);
  }

  new MutationObserver(scheduleUpsellLayouts).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  window.addEventListener('resize', scheduleUpsellLayouts);
  document.addEventListener('DOMContentLoaded', scheduleUpsellLayouts);
})();

/* ---------------------------------------------------------------------------
 * Subscription-bundle cart entry — "Remove" clears the whole box.
 *
 * A mixed 3-tub subscription is several cart lines (Shopify cannot merge lines
 * that carry a selling plan). snippets/cart-line-items.liquid groups them into
 * one entry when the `gigi_group_bundle_cart_lines` theme setting is on, and
 * that entry's Remove carries every line key. Removing them one at a time would
 * leave a half-box mid-flight, so they go in a single /cart/update.js call.
 *
 * Delegated from the document and registered once, because the cart markup is
 * re-rendered by the drawer, the cart page and the AJAX partial alike. Inert
 * when the setting is off: nothing matches the selector.
 * ------------------------------------------------------------------------ */
(function () {
  if (window.__gigiBundleRemoveBound) { return; }
  window.__gigiBundleRemoveBound = true;

  // CAPTURE phase: the bundle row also carries `data-item-remove` (the theme
  // needs it to count removable rows and paint the empty-cart state), and the
  // theme binds its own click handler to that attribute which would remove a
  // single line. Handling this on the way DOWN and stopping propagation means
  // the event never reaches that handler, so the whole box goes in one call.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-bundle-remove]');
    if (!trigger) { return; }
    e.preventDefault();
    e.stopPropagation();
    if (trigger.dataset.busy === '1') { return; }
    trigger.dataset.busy = '1';

    var updates = {};
    (trigger.getAttribute('data-bundle-keys') || '')
      .split(',')
      .forEach(function (key) { if (key) { updates[key] = 0; } });
    if (!Object.keys(updates).length) { trigger.dataset.busy = ''; return; }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        // The cart page renders server-side, so reload it; the drawer listens
        // for the theme's own refresh event.
        if (window.location.pathname.indexOf('/cart') === 0) {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        }
      })
      .catch(function (err) {
        console.error('[gigi] bundle remove failed', err);
        trigger.dataset.busy = '';
      });
  }, true);
})();

/**
 * Header H: numeric cart-count bubble (header setting "Numeric cart count on
 * the cart icon"). The <span class="gigi-cart-count"> elements only render
 * when that setting is on, so this whole block is inert otherwise.
 * theme.js owns the cart__toggle--has-items class (which shows/hides the
 * bubble); the number itself is refreshed from /cart.js whenever the theme
 * announces a cart change or flips that class.
 */
(function () {
  var badges = document.querySelectorAll('[data-gigi-cart-count]');
  if (!badges.length) { return; }

  var timer = null;
  function refresh() {
    // Debounce: several events fire around one add-to-cart.
    if (timer) { clearTimeout(timer); }
    timer = setTimeout(function () {
      timer = null;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          badges.forEach(function (badge) { badge.textContent = cart.item_count; });
        })
        .catch(function () { /* keep the server-rendered number */ });
    }, 150);
  }

  ['theme:cart:added', 'theme:cart:loaded', 'theme:cart:refresh', 'theme:cart:update'].forEach(function (name) {
    document.addEventListener(name, refresh);
  });

  // Fallback for cart mutations that only surface as the has-items class flip.
  var observer = new MutationObserver(refresh);
  document.querySelectorAll('.cart__toggle').forEach(function (toggle) {
    observer.observe(toggle, { attributes: true, attributeFilter: ['class'] });
  });
})();

/**
 * Header H: "Join Community" drawer link (gigi_drawer_join_label header
 * setting). Closes the nav drawer, then opens the Gigi signup popup via its
 * external hook (with a small delay so the drawer slides away first).
 */
(function () {
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-gigi-join-community]');
    if (!trigger) { return; }
    e.preventDefault();
    var closeBtn = document.querySelector('#nav-drawer-header .drawer__close-button');
    if (closeBtn) { closeBtn.click(); }
    setTimeout(function () {
      // The popup's script listens for this and runs its own open().
      document.dispatchEvent(new CustomEvent('gigi:signup:open'));
    }, 350);
  });
})();
